import { Mutation } from 'graphql/generated/graphqlTypes';

export function mockedUnregisterMobileDeviceData(
  unregisterMobileDeviceById: string
): Pick<Mutation, 'unregisterMobileDeviceById'> {
  return {
    unregisterMobileDeviceById
  };
}

export const mockedUnregisterMobileDeviceDataForMutation = mockedUnregisterMobileDeviceData(
  'mockedAutomatedTestsUIAdminVisitorId'
);
export const mockedUnregisterMobileDeviceDataForMutation1 =
  mockedUnregisterMobileDeviceData('mockedVisitorIdExternalUser2');
